import { Typography, styled } from "@material-ui/core";

export const SummaryTitleText = styled(Typography)({
  color: "#707087",
  fontFamily: "'Inter', 'sans-serif'",
  fontSize: "14px",
  fontWeight: 400,
  // Dark mode (additive): only applies under the `.dark` root; light unchanged.
  ".dark &": {
    color: "hsl(var(--sds-muted-foreground))",
  },
});
